/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { INurse } from 'app/shared/model/nurse.model';
import { IAdmission } from 'app/shared/model/admission.model';
import { IPressure } from 'app/shared/model/pressure.model';
import { IOtherVitals } from 'app/shared/model/other-vitals.model';
import { IVitals } from 'app/shared/model/vitals.model';

export interface INursingNotes {
  id?: string;
  date?: number | null;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  notes?: string;
  nurse?: INurse;
  admission?: IAdmission | null;
  pressure?: IPressure | null;
  otherVitals?: IOtherVitals | null;
  vitals?: IVitals | null;
}

export const defaultValue: Readonly<INursingNotes> = {
  active: false,
};
